var moduleMap = {
	"./OperationalReviewPage": () => {
		return Promise.all([__webpack_require__.e(2322), __webpack_require__.e(4893), __webpack_require__.e(705), __webpack_require__.e(8589)]).then(() => (() => ((__webpack_require__(38589)))));
	},
	"./ReviewLandingPage": () => {
		return Promise.all([__webpack_require__.e(2322), __webpack_require__.e(4893), __webpack_require__.e(9923)]).then(() => (() => ((__webpack_require__(29923)))));
	},
	"./CreateReviewPage": () => {
		return Promise.all([__webpack_require__.e(2322), __webpack_require__.e(4893), __webpack_require__.e(7611)]).then(() => (() => ((__webpack_require__(57611)))));
	},
	"./BusinessReviewApp": () => {
		return Promise.all([__webpack_require__.e(2322), __webpack_require__.e(4893), __webpack_require__.e(705), __webpack_require__.e(7349)]).then(() => (() => ((__webpack_require__(67349)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});